import { css } from "@emotion/css";
import React from "react";
import { Card, Icon, Menu } from "semantic-ui-react";
import { getIsWhiteLabeled } from "../../helpers/PermissionHelper";
import "../../styles/ui.scss";

interface BCTabMenuBarProps {
  title?: string;
  subtitle?: any;
  subtitleLists?: any[];
  tabs: any[];
  activeTab: string;
  setActiveTab: any;
  isGreaterThanMobile?: boolean;
  brokerColor?: any;
  dropdown?: any;
  menubarButton?: any;
}

const BCTabMenuBar = ({ ...props }: BCTabMenuBarProps) => {
  const brokerActiveTabOverrideCSS = css`
  .active.item {
    color: ${props.brokerColor ? props.brokerColor : "black"}!important;
    border-color: ${props.brokerColor ? props.brokerColor : "black"}!important;
    font-weight: normal;
  }
  & :hover {
    color: ${props.brokerColor ? props.brokerColor : "black"}!important;
  }
  `;
  return (
    <Card fluid className='tab-menubar-container'>
      <div className="tab-menubar">
        {props.title && <div className="tab-menubar-title-container">
          <div className="tab-menubar-header-container">
            <div className="tab-menubar-header">
              <div className="tab-menubar-title">{props.title}</div>
              <div className="tab-menubar-subtitle">{props.subtitle}</div>
            </div>
            <div>
              {props.menubarButton ? props.menubarButton : null}
            </div>
          </div>
          {props.subtitleLists && props.subtitleLists.map((subtitleList, i) => 
          <div className="tab-menubar-subtitle-list-wrapper" key={`tab-menubar-subitile-wrapper-${i}`}>
            {subtitleList && subtitleList.map((subtitle, i) => 
              <div className={subtitle.listItemClass || "tab-menubar-subtitle-list-item"} key={`tab-menubar-subitile-item-${i}`}><span>{subtitle.title}:</span>{subtitle.detail}</div>
            )}
          </div>)}
          {props.dropdown && props.dropdown}
        </div>}
        <Menu className={`tab-menu ${(getIsWhiteLabeled()) && brokerActiveTabOverrideCSS}`} pointing secondary fluid widths={props.tabs.length as any}>
          {props.tabs.map((tab, i) => {
            let tabName = tab;
            if (tab.name) {
              tabName = tab.name;
            }

            if (!props.isGreaterThanMobile && tab.icon) {
              return (
                <Menu.Item
                  key={"tab_" + i}
                  active={props.activeTab === tabName.toLocaleUpperCase()}
                  onClick={() =>  props.setActiveTab(tabName.toLocaleUpperCase())}
                >
                  <Icon size="large" name={tab.icon} />
                </Menu.Item>
              );
            }
            else {
              return (
                <Menu.Item
                  key={"tab_" + i}
                  name={tabName.toLocaleUpperCase()}
                  active={props.activeTab === tabName.toLocaleUpperCase()}
                  onClick={() =>  props.setActiveTab(tabName.toLocaleUpperCase())}
                />
              );
            }
            
          })}
        </Menu>
      </div>
    </Card>
  );
};

export default BCTabMenuBar;